import { RuleVersionType } from '../documents/enums';
import { LoanChecklist, LoanChecklistRule } from '../loans/types';

export const checklistMockData = (type: string = '') => {
  return new Array(10).fill(null).map(
    (_, index) =>
      ({
        id: `${index + 1}`,
        name: `Mock ${type}Checklist ${index + 1}`,
        metadata: {
          documentType: [
            'Employment Verification',
            'Income Verification',
            'Loan Estimate',
          ],
          category: 'Assets',
          version: 'final',
          description: `Mock Description for Checklist ${index + 1}`,
          priority: 'High',
          createdBy: 'Mock User',
        },
        active: true,
        rules: new Array(50).fill(null).map((_, rulIndex) => ({
          name: `Mock ${type}Rule Name ${rulIndex + 1}`,
          description: `Mock Rule Description ${rulIndex + 1}`,
          ruleSelected: false,
          definition: {
            ruleType: 'Automatic',
            ruleSequenceNo: rulIndex + 1,
            ruleFunction: '',
            active: true,
            expression:
              '[Proposal - Research Q4.Credit report fee] == [Proposal - Research Q3.Credit report fee]',
            trueConstraint: 'Mock True Constraint',
            falseConstraint: 'Mock False Constraint',
            ruleSelected: false,
            version: RuleVersionType.FINAL,
          },
        })),
      }) as LoanChecklist,
  );
};

export const rulesMockData = () => {
  return new Array(50).fill(null).map(
    (_, rulIndex) =>
      ({
        id: `${rulIndex + 1}`,
        name: `Mock Global Rule Name ${rulIndex + 1}`,
        description: `Mock Rule Description ${rulIndex + 1}`,
        ruleSelected: false,
        definition: {
          ruleType: 'Automatic',
          ruleSequenceNo: rulIndex + 1,
          ruleFunction: '',
          draftRule: false,
          active: true,
          expression:
            '[Proposal - Research Q4.Credit report fee] == [Proposal - Research Q3.Credit report fee]',
          trueConstraint: 'Mock True Constraint',
          falseConstraint: 'Mock False Constraint',
          ruleSelected: false,
          version: RuleVersionType.FINAL,
        },
      }) as LoanChecklistRule,
  );
};
